import { SVGProps } from 'react';

export const HelpIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_28019_33221)">
        <path
          d="M18 9C18 13.9717 13.9702 18 9 18C4.02979 18 0 13.9717 0 9C0 4.03124 4.02979 0 9 0C13.9702 0 18 4.03124 18 9ZM9.24151 2.97581C7.2638 2.97581 6.00242 3.80892 5.01191 5.2896C4.88359 5.48144 4.92652 5.74015 5.11044 5.87961L6.36968 6.83441C6.55857 6.97765 6.8277 6.94357 6.97446 6.7574C7.62275 5.93514 8.06727 5.45832 9.054 5.45832C9.79537 5.45832 10.7124 5.93546 10.7124 6.65438C10.7124 7.19786 10.2637 7.47697 9.53173 7.88737C8.67803 8.36594 7.54839 8.96157 7.54839 10.4516V10.5968C7.54839 10.8373 7.74337 11.0323 7.98387 11.0323H10.0161C10.2566 11.0323 10.4516 10.8373 10.4516 10.5968V10.5484C10.4516 9.5155 13.4705 9.4725 13.4705 6.67742C13.4705 4.57251 11.2871 2.97581 9.24151 2.97581ZM9 11.9758C8.0795 11.9758 7.33065 12.7247 7.33065 13.6452C7.33065 14.5656 8.0795 15.3145 9 15.3145C9.9205 15.3145 10.6694 14.5656 10.6694 13.6452C10.6694 12.7247 9.9205 11.9758 9 11.9758Z"
          fill="#0D3F5E"
        />
      </g>
      <defs>
        <clipPath id="clip0_28019_33221">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
